module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_39.0f8e5e9c.jpeg";